import React, {useMemo} from "react";
import moment from "moment/moment";
import {hasNexPark, hasNexResponse} from "../../../../model/api/nexParkInstance/instancesChecker";
import {RadioButton, TextArea} from "@progress/kendo-react-inputs";
import {BillingMode} from "../../../../model/api/customers/billing-mode";
import {Label} from "@progress/kendo-react-labels";
import {DropDownList} from "@progress/kendo-react-dropdowns";
import {ICustomer} from "../../../../model";
import {IBillingTerm} from "../../../../model/api/customers/billing-term";
import {BillingModalType} from "./BillingInvoicesSection";
import styles from "../BillingSection.module.scss"

interface GenerateInvoiceFormProps {
    serviceType: BillingMode;
    billingModalType: BillingModalType;
    onServiceChange: (value: BillingMode) => void;
    comment: string;
    onCommentChange: (value: string) => void;
    dueDate: Date;
    onDateChange: (value: Date) => void;
    onTermChange: (value: string) => void;
    customer: ICustomer;
    invoiceTerm?: string | undefined;
    billingTerms: IBillingTerm[];
}

const GenerateInvoiceForm = ({
                                 serviceType,
                                 billingModalType,
                                 onServiceChange,
                                 comment,
                                 onCommentChange,
                                 dueDate,
                                 onDateChange,
                                 onTermChange,
                                 customer,
                                 invoiceTerm,
                                 billingTerms
                             }: GenerateInvoiceFormProps) => {
    const months = useMemo(() => {
        return Array.from({ length: 24 }).map((_, i) => {
            const date = moment().subtract(i, 'months').startOf('month').toDate();
            return {
                name: moment(date).format('MMM YYYY'),
                id: date.getTime(),
                value: date
            };
        });
    }, []);

    const selectedMonthItem = useMemo(() => {
        return months.find(m => moment(m.value).isSame(dueDate, 'month')) || months[0];
    }, [months, dueDate]);

    const selectedTermItem = useMemo(() => {
        if (!invoiceTerm) return null;
        return billingTerms.find(t => String(t.id) === String(invoiceTerm)) || null;
    }, [billingTerms, invoiceTerm]);

    return (
        <div>
            <div style={{ display: 'flex', gap: '20px' }}>
                {hasNexPark(customer) &&
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <RadioButton
                            id="nexPark"
                            name="serviceType"
                            value={BillingMode.NexPark}
                            checked={serviceType === BillingMode.NexPark}
                            onChange={() => onServiceChange(BillingMode.NexPark)}
                        />
                        <label
                            htmlFor="nexPark"
                            style={{ cursor: 'pointer', userSelect: 'none', marginBottom: 0 }}
                        >
                            NexPark
                        </label>
                    </div>
                }

                {hasNexResponse(customer) &&
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <RadioButton
                            id="nexResponse"
                            name="serviceType"
                            value={BillingMode.NexResponse}
                            checked={serviceType === BillingMode.NexResponse}
                            onChange={() => onServiceChange(BillingMode.NexResponse)}
                        />
                        <label
                            htmlFor="nexResponse"
                            style={{ cursor: 'pointer', userSelect: 'none', marginBottom: 0 }}
                        >
                            NexResponse
                        </label>
                    </div>
                }
            </div>

            <div className={styles.optionsRow}>
                {hasNexPark(customer) && serviceType === BillingMode.NexPark && <div className={styles.optionTerm}>
                    <Label style={{ marginBottom: '8px', display: 'block' }}>Terms</Label>
                    <DropDownList
                        data={billingTerms}
                        textField="name"
                        dataItemKey="id"
                        value={selectedTermItem}
                        onChange={(e: any) => onTermChange(e.value.id)}
                    />
                </div> }

                {hasNexResponse(customer) && serviceType === BillingMode.NexResponse && <div className={styles.optionTerm}>
                    <Label style={{ marginBottom: '8px', display: 'block' }}>Terms</Label>
                    <DropDownList
                        data={billingTerms}
                        textField="name"
                        dataItemKey="id"
                        value={selectedTermItem}
                        onChange={(e: any) => onTermChange(e.value.id)}
                    />
                </div> }

                <div className={styles.optionBilling}>
                    <Label style={{ marginBottom: '8px', display: 'block' }}>Billing Period</Label>
                    <DropDownList
                        data={months}
                        textField="name"
                        dataItemKey="id"
                        disabled={true}
                        value={selectedMonthItem}
                        onChange={(e: any) => onDateChange(e.value.value)}
                    />
                </div>
            </div>



            {billingModalType === BillingModalType.GenerateInvoice &&
                <div style={{ marginTop: '20px' }}>
                    <Label style={{ marginBottom: '8px', display: 'block' }}>Comment</Label>
                    <TextArea
                        rows={4}
                        placeholder="Type in comment here..."
                        value={comment}
                        onChange={(e) => onCommentChange(e.value as string)}
                    />
                </div>
            }
        </div>
    );
};

export default GenerateInvoiceForm;
